module.exports = __webpack_public_path__ + "492a599eb2ab8d5559e711fff8b455ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/valorant/ascent.png
// module id = 443
// module chunks = 0